import { createFileRoute } from '@tanstack/react-router'
import { requireGuest } from '@/lib/auth-guard'
import SignUpPage from '@/pages/SignUp'

// Signups disabled 2026-07-14: every link to this page is still switched off
// (Header, SignIn, Hero, FooterCta). The page answers to its address, and the
// backend decides: it refuses new accounts unless the flag file
// pb_data/allow_signups is there (hooks/user_validation.go).
export const Route = createFileRoute('/sign-up')({
  ...requireGuest(),
  component: SignUpPage,
})
